export const INDIA_COUNTRY = "India";

export const getPropertyCountry = (propertyId) => {
  try {
    const stored = localStorage.getItem("propertiesList");
    if (!stored) return null;
    const property = JSON.parse(stored).find(
      (p) => String(p._id) === String(propertyId),
    );
    return property?.country ?? null;
  } catch {
    return null;
  }
};

export const isIndiaProperty = (country) => country === INDIA_COUNTRY;

export const getCurrencySymbol = (currencyOrCountry) => {
  if (!currencyOrCountry) return "$";
  const value = String(currencyOrCountry).toLowerCase();
  if (value === "inr" || value === INDIA_COUNTRY.toLowerCase()) {
    return "₹";
  }
  return "$";
};

export const formatPaymentAmount = (cents, currencyOrCountry) =>
  `${getCurrencySymbol(currencyOrCountry)}${(cents / 100).toFixed(2)}`;

/** Format a whole-unit shop price (e.g. $30.00 or ₹150). */
export const formatShopAmount = (amount, currency = "usd") => {
  const symbol = getCurrencySymbol(currency);
  if (String(currency).toLowerCase() === "inr") {
    return `${symbol}${Math.round(Number(amount))}`;
  }
  return `${symbol}${Number(amount).toFixed(2)}`;
};

export const formatCreditRate = (credits, pricePerCreditCents, currency) =>
  formatPaymentAmount(credits * pricePerCreditCents, currency);

export const DEFAULT_PRICING = {
  currency: "usd",
  pricePerCreditCents: 18,
  minSignedPurchaseCents: 9000,
  minCreditsPurchase: 500,
};
